// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f8jXni3w8NScvhJgkSYT {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  background: transparent;
  border-top: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  font-family: var(--vnsc-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  font-size: var(--vnsc-font-size-xs, 11px);
  color: var(--vnsc-text-primary, #d1d4dc);
  position: relative;
  z-index: var(--vnsc-z-footer, 55);
  gap: 12px;
}

.wCQgYh7N9SFyyHEwm1Ow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ESVFmue8Bk1vurzKO88a {
  margin-left: auto;
  gap: 12px;
}


/* Layout Selector */
.IfUJ4vk0lU4ztAGwIRLf {
  position: relative;
}

.H8LZxDcjSYGLr7d1mptZ {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: var(--vnsc-font-size-xs, 11px);
  font-weight: 500;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.H8LZxDcjSYGLr7d1mptZ:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}

.HJvbcRnEvDxLJe7b9Ce6 {
  color: var(--vnsc-accent, #2962ff);
  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));
  border-color: var(--vnsc-accent, #2962ff);
}

.jppzH_Z_5qSrUU91gTyS {
  font-size: 8px;
}

.cxwBnowXxSxAMHM3puy0 {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 6px;
  background: var(--vnsc-bg-secondary, #1e222d);
  border: 1px solid var(--vnsc-border, #2a2e39);
  border-radius: 6px;
  padding: 6px;
  min-width: 240px;
  z-index: var(--vnsc-z-popover, 110);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.o76JsuhTyclot2rLtO9R {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 4px;
}

.yclWlURvAxiUHYA0RiLU {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: var(--vnsc-text-muted, #787b86);
  font-size: 10px;
  font-weight: 500;
  flex-shrink: 0;
}

.p2j9XjQK7APCEupMJPFq {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.XhydUGpbWNY9RkD30CyO {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--vnsc-border, #2a2e39);
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  padding: 3px;
  transition: border-color 0.15s ease;
}

.XhydUGpbWNY9RkD30CyO:hover {
  border-color: var(--vnsc-text-secondary, #787b86);
}

.gDGjOgiGsKhVF8MO77aO {
  border-color: var(--vnsc-primary, #2962ff);
}

.CZtEfze3pSnj0ESuPpps {
  display: grid;
  width: 20px;
  height: 20px;
  gap: 1px;
}

.ktMB8UrOKPM542jrHrz4 {
  background: transparent;
  border: 1px solid var(--vnsc-text-muted, #787b86);
  border-radius: 1px;
}

.gDGjOgiGsKhVF8MO77aO .ktMB8UrOKPM542jrHrz4 {
  border-color: var(--vnsc-primary, #2962ff);
  background: var(--vnsc-primary, #2962ff);
}

/* Sync Controls */
.y2Fma15n2_fL4fYdDgvx {
  display: flex;
  align-items: center;
  gap: 6px;
}

.RDBu8yIny4T6WUg5QkDI {
  padding: 4px 10px;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: var(--vnsc-font-size-2xs, 10px);
  font-weight: 500;
  transition: all 0.15s ease;
}

.RDBu8yIny4T6WUg5QkDI:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  background: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));
  border-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.16));
}

.Vv29ZkAxK01pn4QX73WZ {
  color: var(--vnsc-text-on-primary, #ffffff);
  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));
  border-color: var(--vnsc-accent, #6366f1);
  font-weight: 600;
  box-shadow: 0 0 10px rgba(99, 102, 241, 0.15);
}

/* Right side */
.OLbk4yRBv1yBXlHeuYr6 {
  font-weight: 600;
  font-size: var(--vnsc-font-size-xs, 11px);
  color: var(--vnsc-text-primary, #d1d4dc);
}

.BpKSSd5a3R7EKMHJwbui {
  display: flex;
  align-items: center;
}

.KMY9zRmPmoECivDPMKq8 {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--vnsc-success, #089981);
  animation: Us37xTegYi2WVec3kJbD 2s ease-in-out infinite;
}

@keyframes Us37xTegYi2WVec3kJbD {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(1.3); }
}

.SbvdqyEbswCdKRtIy_bf {
  font-variant-numeric: tabular-nums;
  font-family: var(--vnsc-font-mono, ui-monospace, SFMono-Regular, monospace);
  font-size: 10px;
  color: var(--vnsc-text-muted, #787b86);
}

/* Light theme overrides */
[data-chart-mode="light"] .RDBu8yIny4T6WUg5QkDI {
  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.03));
  border-color: var(--vnsc-border, rgba(0, 0, 0, 0.08));
  color: var(--vnsc-text-secondary, #475569);
}
[data-chart-mode="light"] .RDBu8yIny4T6WUg5QkDI:hover {
  background: var(--vnsc-bg-active, rgba(0, 0, 0, 0.06));
  border-color: var(--vnsc-border-hover, rgba(0, 0, 0, 0.12));
  color: var(--vnsc-text-primary, #0f172a);
}
[data-chart-mode="light"] .Vv29ZkAxK01pn4QX73WZ {
  color: var(--vnsc-text-on-primary, #ffffff);
  background: var(--vnsc-accent, #2563eb);
  border-color: var(--vnsc-accent, #2563eb);
}
[data-chart-mode="light"] .H8LZxDcjSYGLr7d1mptZ {
  color: var(--vnsc-text-secondary, #475569);
}
[data-chart-mode="light"] .H8LZxDcjSYGLr7d1mptZ:hover {
  color: var(--vnsc-text-primary, #0f172a);
  border-color: var(--vnsc-border-secondary, #cbd5e1);
  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.04));
}
[data-chart-mode="light"] .Hy3FMOV2qMLBYdXN_agw {
  color: var(--vnsc-text-secondary, #475569);
}
[data-chart-mode="light"] .Hy3FMOV2qMLBYdXN_agw:hover {
  color: var(--vnsc-text-primary, #0f172a);
  border-color: var(--vnsc-border-secondary, #cbd5e1);
  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.04));
}
[data-chart-mode="light"] .QRjOOGNae7WKWhE_weAt {
  background-color: var(--vnsc-border-secondary, #cbd5e1);
}
[data-chart-mode="light"] .SbvdqyEbswCdKRtIy_bf {
  color: var(--vnsc-text-secondary, #475569);
}
[data-chart-mode="light"] .OLbk4yRBv1yBXlHeuYr6 {
  color: var(--vnsc-text-primary, #0f172a);
}

/* ── Mobile Pagination Dots ────────────────────────────────────────── */
.xsbYd4uaoBUWynBw95Yf {
  display: none;
}

.QRjOOGNae7WKWhE_weAt {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.25));
  border: 2px solid transparent;
  padding: 0;
  cursor: pointer;
  transform: scale(1);
  transition: all 0.2s ease;
}

.Kfu985owOdgPvJ5uKRpO {
  background-color: var(--vnsc-accent, #22d3ee);
  transform: scale(1.3);
}

/* Desktop content — visible by default */
.oRoDt2Ja8eeIFAZJwCDe {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
}

/* Responsive */
.h7T8LXr165a2K1baUZIt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.Tc04L5z_nG8PPOanI2tD {
  display: inline-block;
  margin-left: 4px;
}

/* UIUX S5: cum Pine/Strategy/Paper thu ve icon <1440px (title tooltip giu nguyen). */
@media (max-width: 1439px) {
  .HABkMfZ5UIEo0zQBmrgT .Tc04L5z_nG8PPOanI2tD {
    display: none;
  }
}

/* Mobile breakpoint */
@media (max-width: 768px) {
  .ki3jMXoTRLSrVDVQBqOY {
    display: none;
  }

  .f8jXni3w8NScvhJgkSYT {
    height: 36px;
    min-height: 36px;
    padding: 0 12px;
    padding-bottom: env(safe-area-inset-bottom, 8px);
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--vnsc-bg-secondary, #0c1017);
    flex-wrap: nowrap;
    gap: 10px;
    border-top: 1px solid var(--vnsc-border, rgba(148,163,184,0.12));
  }

  .xsbYd4uaoBUWynBw95Yf {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .oRoDt2Ja8eeIFAZJwCDe {
    display: none;
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .f8jXni3w8NScvhJgkSYT {
    border-top-width: 2px;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .f8jXni3w8NScvhJgkSYT,
  .H8LZxDcjSYGLr7d1mptZ,
  .XhydUGpbWNY9RkD30CyO,
  .RDBu8yIny4T6WUg5QkDI {
    transition: none;
  }

  .KMY9zRmPmoECivDPMKq8 {
    animation: none;
  }
}

/* Print styles */
@media print {
  .f8jXni3w8NScvhJgkSYT {
    display: none;
  }
}

.HABkMfZ5UIEo0zQBmrgT {
  display: flex;
  align-items: center;
  gap: 4px;
  border-left: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  padding-left: 8px;
}

/* P1 handoff: tag phạm vi timeframe (chỉ chart đang focus), khỏi nhầm cả 4 ô. */
.c5aeU8qwq9NCf2AVm5cA {
  font-size: 10px;
  color: var(--vnsc-text-muted, #787b86);
  white-space: nowrap;
}

.Hy3FMOV2qMLBYdXN_agw {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: var(--vnsc-font-size-xs, 11px);
  font-weight: 500;
  transition: all 0.15s ease;
}

.Hy3FMOV2qMLBYdXN_agw:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}

.Bt5GUyBwVPwZjwNwI2Jw {
  background: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.12));
  color: var(--vnsc-accent, #2962ff) !important;
  border-color: var(--vnsc-accent, #2962ff) !important;
}

.Hy3FMOV2qMLBYdXN_agw:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: transparent !important;
  background: transparent !important;
  color: var(--vnsc-text-secondary, #787b86) !important;
}
`, "",{"version":3,"sources":["webpack://./src/widget/components/footer/MultiChartsFooter.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,mEAAmE;EACnE,uGAAuG;EACvG,yCAAyC;EACzC,wCAAwC;EACxC,kBAAkB;EAClB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;;AAGA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,wCAAwC;EACxC,qEAAqE;EACrE,2DAA2D;AAC7D;;AAEA;EACE,kCAAkC;EAClC,6DAA6D;EAC7D,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,+DAA+D;EAC/D,kBAAkB;EAClB,2DAA2D;EAC3D,0CAA0C;EAC1C,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,4DAA4D;EAC5D,iEAAiE;AACnE;;AAEA;EACE,2CAA2C;EAC3C,8DAA8D;EAC9D,yCAAyC;EACzC,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,uDAA4C;AAC9C;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,YAAY,EAAE,qBAAqB,EAAE;AAC7C;;AAEA;EACE,kCAAkC;EAClC,2EAA2E;EAC3E,eAAe;EACf,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,qDAAqD;EACrD,qDAAqD;EACrD,0CAA0C;AAC5C;AACA;EACE,sDAAsD;EACtD,2DAA2D;EAC3D,wCAAwC;AAC1C;AACA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,yCAAyC;AAC3C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;EACxC,mDAAmD;EACnD,qDAAqD;AACvD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;EACxC,mDAAmD;EACnD,qDAAqD;AACvD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;AAC1C;;AAEA,yEAAyE;AACzE;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,6BAA6B;EAC7B,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,qFAAqF;AACrF;EACE;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;IAC7C,iBAAiB;IACjB,SAAS;IACT,gEAAgE;EAClE;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;IAIE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oEAAoE;EACpE,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,qEAAqE;EACrE,2DAA2D;AAC7D;;AAEA;EACE,0DAA0D;EAC1D,6CAA6C;EAC7C,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;EAClC,qDAAqD;AACvD","sourcesContent":[".multiChartsFooter {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  height: 32px;\r\n  padding: 0 12px;\r\n  background: transparent;\r\n  border-top: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  font-family: var(--vnsc-font-family, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif);\r\n  font-size: var(--vnsc-font-size-xs, 11px);\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  position: relative;\r\n  z-index: var(--vnsc-z-footer, 55);\r\n  gap: 12px;\r\n}\r\n\r\n.footerSection {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.footerRight {\r\n  margin-left: auto;\r\n  gap: 12px;\r\n}\r\n\r\n\r\n/* Layout Selector */\r\n.layoutSelectorContainer {\r\n  position: relative;\r\n}\r\n\r\n.layoutBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 3px 8px;\r\n  border: 1px solid transparent;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  font-size: var(--vnsc-font-size-xs, 11px);\r\n  font-weight: 500;\r\n  transition: color 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.layoutBtn:hover {\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\r\n}\r\n\r\n.layoutBtnActive {\r\n  color: var(--vnsc-accent, #2962ff);\r\n  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.chevron {\r\n  font-size: 8px;\r\n}\r\n\r\n.layoutDropdown {\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 0;\r\n  margin-bottom: 6px;\r\n  background: var(--vnsc-bg-secondary, #1e222d);\r\n  border: 1px solid var(--vnsc-border, #2a2e39);\r\n  border-radius: 6px;\r\n  padding: 6px;\r\n  min-width: 240px;\r\n  z-index: var(--vnsc-z-popover, 110);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.layoutRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 3px 4px;\r\n}\r\n\r\n.layoutRowLabel {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 16px;\r\n  height: 16px;\r\n  color: var(--vnsc-text-muted, #787b86);\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.layoutRowOptions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.layoutOption {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border: 1px solid var(--vnsc-border, #2a2e39);\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  padding: 3px;\r\n  transition: border-color 0.15s ease;\r\n}\r\n\r\n.layoutOption:hover {\r\n  border-color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.layoutOptionSelected {\r\n  border-color: var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.miniGrid {\r\n  display: grid;\r\n  width: 20px;\r\n  height: 20px;\r\n  gap: 1px;\r\n}\r\n\r\n.miniCell {\r\n  background: transparent;\r\n  border: 1px solid var(--vnsc-text-muted, #787b86);\r\n  border-radius: 1px;\r\n}\r\n\r\n.layoutOptionSelected .miniCell {\r\n  border-color: var(--vnsc-primary, #2962ff);\r\n  background: var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n/* Sync Controls */\r\n.syncGroup {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.syncBtn {\r\n  padding: 4px 10px;\r\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  border-radius: 6px;\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  font-size: var(--vnsc-font-size-2xs, 10px);\r\n  font-weight: 500;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.syncBtn:hover {\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  background: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));\r\n  border-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.16));\r\n}\r\n\r\n.syncBtnActive {\r\n  color: var(--vnsc-text-on-primary, #ffffff);\r\n  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));\r\n  border-color: var(--vnsc-accent, #6366f1);\r\n  font-weight: 600;\r\n  box-shadow: 0 0 10px rgba(99, 102, 241, 0.15);\r\n}\r\n\r\n/* Right side */\r\n.chartInfo {\r\n  font-weight: 600;\r\n  font-size: var(--vnsc-font-size-xs, 11px);\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n}\r\n\r\n.statusItem {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.liveDot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  background: var(--vnsc-success, #089981);\r\n  animation: livePulse 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes livePulse {\r\n  0%, 100% { opacity: 1; transform: scale(1); }\r\n  50% { opacity: 0.5; transform: scale(1.3); }\r\n}\r\n\r\n.timeText {\r\n  font-variant-numeric: tabular-nums;\r\n  font-family: var(--vnsc-font-mono, ui-monospace, SFMono-Regular, monospace);\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-muted, #787b86);\r\n}\r\n\r\n/* Light theme overrides */\r\n[data-chart-mode=\"light\"] .syncBtn {\r\n  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.03));\r\n  border-color: var(--vnsc-border, rgba(0, 0, 0, 0.08));\r\n  color: var(--vnsc-text-secondary, #475569);\r\n}\r\n[data-chart-mode=\"light\"] .syncBtn:hover {\r\n  background: var(--vnsc-bg-active, rgba(0, 0, 0, 0.06));\r\n  border-color: var(--vnsc-border-hover, rgba(0, 0, 0, 0.12));\r\n  color: var(--vnsc-text-primary, #0f172a);\r\n}\r\n[data-chart-mode=\"light\"] .syncBtnActive {\r\n  color: var(--vnsc-text-on-primary, #ffffff);\r\n  background: var(--vnsc-accent, #2563eb);\r\n  border-color: var(--vnsc-accent, #2563eb);\r\n}\r\n[data-chart-mode=\"light\"] .layoutBtn {\r\n  color: var(--vnsc-text-secondary, #475569);\r\n}\r\n[data-chart-mode=\"light\"] .layoutBtn:hover {\r\n  color: var(--vnsc-text-primary, #0f172a);\r\n  border-color: var(--vnsc-border-secondary, #cbd5e1);\r\n  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.04));\r\n}\r\n[data-chart-mode=\"light\"] .tabBtn {\r\n  color: var(--vnsc-text-secondary, #475569);\r\n}\r\n[data-chart-mode=\"light\"] .tabBtn:hover {\r\n  color: var(--vnsc-text-primary, #0f172a);\r\n  border-color: var(--vnsc-border-secondary, #cbd5e1);\r\n  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.04));\r\n}\r\n[data-chart-mode=\"light\"] .paginationDot {\r\n  background-color: var(--vnsc-border-secondary, #cbd5e1);\r\n}\r\n[data-chart-mode=\"light\"] .timeText {\r\n  color: var(--vnsc-text-secondary, #475569);\r\n}\r\n[data-chart-mode=\"light\"] .chartInfo {\r\n  color: var(--vnsc-text-primary, #0f172a);\r\n}\r\n\r\n/* ── Mobile Pagination Dots ────────────────────────────────────────── */\r\n.mobilePagination {\r\n  display: none;\r\n}\r\n\r\n.paginationDot {\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  background-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.25));\r\n  border: 2px solid transparent;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  transform: scale(1);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.paginationDotActive {\r\n  background-color: var(--vnsc-accent, #22d3ee);\r\n  transform: scale(1.3);\r\n}\r\n\r\n/* Desktop content — visible by default */\r\n.desktopContent {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  gap: 12px;\r\n}\r\n\r\n/* Responsive */\r\n.btnIcon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.btnText {\r\n  display: inline-block;\r\n  margin-left: 4px;\r\n}\r\n\r\n/* UIUX S5: cum Pine/Strategy/Paper thu ve icon <1440px (title tooltip giu nguyen). */\r\n@media (max-width: 1439px) {\r\n  .tabGroup .btnText {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Mobile breakpoint */\r\n@media (max-width: 768px) {\r\n  .singleChart {\r\n    display: none;\r\n  }\r\n\r\n  .multiChartsFooter {\r\n    height: 36px;\r\n    min-height: 36px;\r\n    padding: 0 12px;\r\n    padding-bottom: env(safe-area-inset-bottom, 8px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: var(--vnsc-bg-secondary, #0c1017);\r\n    flex-wrap: nowrap;\r\n    gap: 10px;\r\n    border-top: 1px solid var(--vnsc-border, rgba(148,163,184,0.12));\r\n  }\r\n\r\n  .mobilePagination {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n  }\r\n\r\n  .desktopContent {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* High contrast mode */\r\n@media (prefers-contrast: high) {\r\n  .multiChartsFooter {\r\n    border-top-width: 2px;\r\n  }\r\n}\r\n\r\n/* Reduced motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .multiChartsFooter,\r\n  .layoutBtn,\r\n  .layoutOption,\r\n  .syncBtn {\r\n    transition: none;\r\n  }\r\n\r\n  .liveDot {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n/* Print styles */\r\n@media print {\r\n  .multiChartsFooter {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.tabGroup {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  border-left: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\r\n  padding-left: 8px;\r\n}\r\n\r\n/* P1 handoff: tag phạm vi timeframe (chỉ chart đang focus), khỏi nhầm cả 4 ô. */\r\n.scopeTag {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-muted, #787b86);\r\n  white-space: nowrap;\r\n}\r\n\r\n.tabBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 3px 8px;\r\n  border: 1px solid transparent;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  font-size: var(--vnsc-font-size-xs, 11px);\r\n  font-weight: 500;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.tabBtn:hover {\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));\r\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\r\n}\r\n\r\n.tabBtnActive {\r\n  background: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.12));\r\n  color: var(--vnsc-accent, #2962ff) !important;\r\n  border-color: var(--vnsc-accent, #2962ff) !important;\r\n}\r\n\r\n.tabBtn:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n  border-color: transparent !important;\r\n  background: transparent !important;\r\n  color: var(--vnsc-text-secondary, #787b86) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiChartsFooter": `f8jXni3w8NScvhJgkSYT`,
	"footerSection": `wCQgYh7N9SFyyHEwm1Ow`,
	"footerRight": `ESVFmue8Bk1vurzKO88a`,
	"layoutSelectorContainer": `IfUJ4vk0lU4ztAGwIRLf`,
	"layoutBtn": `H8LZxDcjSYGLr7d1mptZ`,
	"layoutBtnActive": `HJvbcRnEvDxLJe7b9Ce6`,
	"chevron": `jppzH_Z_5qSrUU91gTyS`,
	"layoutDropdown": `cxwBnowXxSxAMHM3puy0`,
	"layoutRow": `o76JsuhTyclot2rLtO9R`,
	"layoutRowLabel": `yclWlURvAxiUHYA0RiLU`,
	"layoutRowOptions": `p2j9XjQK7APCEupMJPFq`,
	"layoutOption": `XhydUGpbWNY9RkD30CyO`,
	"layoutOptionSelected": `gDGjOgiGsKhVF8MO77aO`,
	"miniGrid": `CZtEfze3pSnj0ESuPpps`,
	"miniCell": `ktMB8UrOKPM542jrHrz4`,
	"syncGroup": `y2Fma15n2_fL4fYdDgvx`,
	"syncBtn": `RDBu8yIny4T6WUg5QkDI`,
	"syncBtnActive": `Vv29ZkAxK01pn4QX73WZ`,
	"chartInfo": `OLbk4yRBv1yBXlHeuYr6`,
	"statusItem": `BpKSSd5a3R7EKMHJwbui`,
	"liveDot": `KMY9zRmPmoECivDPMKq8`,
	"livePulse": `Us37xTegYi2WVec3kJbD`,
	"timeText": `SbvdqyEbswCdKRtIy_bf`,
	"tabBtn": `Hy3FMOV2qMLBYdXN_agw`,
	"paginationDot": `QRjOOGNae7WKWhE_weAt`,
	"mobilePagination": `xsbYd4uaoBUWynBw95Yf`,
	"paginationDotActive": `Kfu985owOdgPvJ5uKRpO`,
	"desktopContent": `oRoDt2Ja8eeIFAZJwCDe`,
	"btnIcon": `h7T8LXr165a2K1baUZIt`,
	"btnText": `Tc04L5z_nG8PPOanI2tD`,
	"tabGroup": `HABkMfZ5UIEo0zQBmrgT`,
	"singleChart": `ki3jMXoTRLSrVDVQBqOY`,
	"scopeTag": `c5aeU8qwq9NCf2AVm5cA`,
	"tabBtnActive": `Bt5GUyBwVPwZjwNwI2Jw`
};
export default ___CSS_LOADER_EXPORT___;
